import { AccountType } from "dto/access-management/account-dto";
import { useAccountTreeSelector } from "hooks/accounts/account-datasource.hook";
import { useUrlSearch } from "hooks/use-search.hook";
import { useAuthStore, useStores } from "store";
import { IAccount } from "store/devices-store";

const useAccountSelector = () => {
    const { currentUser } = useAuthStore();
    const { commonStore, authStore } = useStores();
    const { getSearchParam, updateSearchParams } = useUrlSearch();

    const accountSelector = useAccountTreeSelector({
        viewableTypes: [AccountType.DPU, AccountType.VAR],
        selectableTypes: [AccountType.VAR],
        defaultSelectedAccount: authStore.isDPUAdmin ? (getSearchParam('accountUuid') ?? commonStore.selectedOrganisation) : currentUser.accountUuid,
        onAccountChange: async (account: IAccount) => {
            if (!authStore.isDPUAdmin) {
                return;
            }
            updateSearchParams({ accountUuid: account?.uuid || null });
        },
    });
    return {
        ...accountSelector,
        isDPUAdmin: authStore.isDPUAdmin
    };
};

export default useAccountSelector;